import { TriangleAlert } from 'lucide-react';

export function AiDetectionWarningPill() {
  return (
    <span
      className="inline-flex h-5 shrink-0 items-center gap-1 rounded-md border border-amber-200 bg-amber-50 px-1.5 text-[11px] font-medium text-amber-800"
      title="Top 25% of experts by accumulated AI warning flags"
    >
      <TriangleAlert className="h-3 w-3" aria-hidden="true" />
      AI warning
    </span>
  );
}
